import { clearAuthSession, getAuthToken } from "./tokenStorage";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL).replace(/\/+$/, "");
console.log("API Base URL:", API_BASE_URL);

export const API_ASSETS_BASE_URL = API_BASE_URL.replace(/\/api$/, "");

const buildHeaders = (headers = {}, includeToken = true, isFormData = false) => {
  const authToken = includeToken ? getAuthToken() : null;

  return {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    ...headers
  };
};

const parseResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await response.json() : await response.text();

  if (!response.ok) {
    const error = new Error(
      (isJson && payload && payload.message) || "Request failed"
    );

    error.status = response.status;
    error.payload = payload;

    if (response.status === 401) {
      clearAuthSession();
    }

    throw error;
  }

  return payload;
};

export const request = async (method, path, data, options = {}) => {
  const { headers, includeToken = true, ...restOptions } = options;
  const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
  const requestOptions = {
    method,
    headers: buildHeaders(headers, includeToken, isFormData),
    ...restOptions
  };

  if (data !== undefined) {
    requestOptions.body = isFormData ? data : JSON.stringify(data);
  }

  const response = await fetch(`${API_BASE_URL}${path}`, requestOptions);
  return parseResponse(response);
};

export const apiClient = {
  get: (path, options) => request("GET", path, undefined, options),
  post: (path, data, options) => request("POST", path, data, options),
  put: (path, data, options) => request("PUT", path, data, options),
  delete: (path, options) => request("DELETE", path, undefined, options)
};
